<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Devolución de Bienes</v-toolbar-title>

                    </v-toolbar>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="6" md="6" align-self="stretch">
                                <v-radio-group v-model="tipo" row dense>
                                    <v-radio label="Remito" value="RE"></v-radio>
                                    <v-radio label="Depósito Origen" value="DE"></v-radio>
                                    <v-radio label="Material" value="MA"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="6" sm="6" md="3" align-self="stretch">
                                <v-row dense>
                                    <v-text-field dense v-if="tipo == 'RE'" v-model="remito" label="Remito"></v-text-field>
                                </v-row>
                                <v-row dense>
                                    <v-select v-if="tipo == 'DE'" v-model="deposito" item-color="green"
                                        color="green darken-2" dense :items="listadodeposito" label="Depósito"
                                        item-text="detalle" item-value="codigo"></v-select>
                                </v-row>
                                <v-row dense>
                                    <v-select v-if="tipo == 'MA'" v-model="codgral" item-color="green"
                                        color="green darken-2" dense :items="listadoequipo" label="Material"
                                        item-text="nombre" item-value="codgral" return-object></v-select></v-row>

                            </v-col>
                            <v-col ols="6" sm="6" md="3" align-self="stretch">
                                <v-btn color="success" @click.stop="cargarDevolucion">Mostrar</v-btn>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
                <v-card>
                    <v-data-table dense :headers="headers" :items="bienesdevueltos" locale="es-ar" class="elevation-1"
                        :items-per-page="10" :footer-props="{
                            itemsPerPageText: 'Bienes por página',
                        }">
                        <template v-slot:top>
                            <v-toolbar flat>

                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="headline">Está seguro que desea borrar?</v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small color="red" @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.fechadev="{ item }">
                            <div class="right-input">
                                <v-text-field dense v-model="item.fechadev" single-line></v-text-field>
                            </div>
                        </template>
                        <template v-slot:item.observ="{ item }">
                            <div class="right-input">
                                <v-text-field dense v-model="item.observ" single-line></v-text-field>
                            </div>
                        </template>
                    </v-data-table>

                </v-card>
                <v-card>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea color="green darken-2" auto-grow rows="6" label="Observaciones" dense
                                    v-model="observ"></v-textarea>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>

                <v-card color="green lighten-4" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>

                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        deshabilitar: false,
        lazy: false,
        fecha: moment().format("DD/MM/YYYY"),
        equipo: "",
        remito: "",
        deposito: "",
        tipo: "",
        listadoequipo: [],
        codgral: "",
        origen: "",
        valid: false,
        observ: "",
        dialogDelete: false,
        editedIndex: -1,
        editedItem: {
            codgral: "",
            fecha: ""
        },
        defaultItem: {
            codgral: "",
            fecha: ""
        },
        bienesdevueltos: [],
        devolucion: [],
        headers: [
            { text: "Código", value: "codgral", width: "5%", sortable: false },
            { text: "Equipo", value: "detalle", width: "40%", sortable: false },
            { text: "Fecha Alquiler", value: "fechaalta", width: "10%", sortable: false },
            { text: "Fecha Devolución", value: "fechadev", width: "10%", sortable: false },
            { text: "Observaciones", value: "observ", width: "30%", sortable: false },
            { text: "Borrar", value: "actions", width: "5%", sortable: false },
        ]
    }),
    watch: {
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    computed: {

        show: {
            get() {
                this.cargarEquipo();
                this.cargarDepositos();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/CargarEquiposDevolucion?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoequipo = response.data;
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
        },

        cargarDepositos() {
            let self = this;
            axios
                .get("/SSGG/CargarDepositos?", {
                    params: {
                        filtrocodigo: "",
                        filtrodetalle: "",
                        filtroestado: "",
                    },
                })
                .then((response) => {
                    self.listadodeposito = response.data;
                })
                .catch((error) => {
                    self.listadodeposito = "";
                    console.log(error);
                });
        },

        cargarDevolucion() {

            let self = this;
            if (self.tipo == "RE" && self.remito != "") {
                axios
                    .get("/SSGG/CargarDevolucionRemito?", {
                        params: {
                            filtroremito: self.remito,
                        },
                    })
                    .then((response) => {
                        self.bienesdevueltos = response.data;
                    })
                    .catch((error) => {
                        self.bienesdevueltos = "";
                        console.log(error);
                    });
            }
            if (self.tipo == "DE" && self.deposito != "") {
                console.log("DEPOSITO " + self.deposito)
                axios
                    .get("/SSGG/CargarDevolucionDeposito?", {
                        params: {
                            filtrodeposito: self.deposito,
                        },
                    })
                    .then((response) => {
                        self.bienesdevueltos = response.data
                    })
                    .catch((error) => {
                        self.bienesdevueltos = "";
                        console.log(error);
                    });
            }
            if (self.tipo == "MA" && self.codgral != "") {
                self.bienesdevueltos.push({
                    codgral: self.codgral.codgral,
                    detalle: self.codgral.detalle,
                    fechadev: moment().format("DD/MM/YYYY")
                }
                )
            }
            if (self.tipo == "" || self.tipo == null) {
                self.bienesdevueltos = []
            }
        },

        deleteItem(item) {
            this.editedIndex = this.bienesdevueltos.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        deleteItemConfirm() {
            this.bienesdevueltos.splice(this.editedIndex, 1);
            this.closeDelete();
        },

        guardar() {
            this.$swal({
                title: "Guardar Devolución",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                var i;
                if (result.value) {
                    let self = this;

                    // Solo enviar items que tengan fecha de devolución cargada
                    var itemsADevolver = self.bienesdevueltos.filter(
                        (item) => item.fechadev != null && item.fechadev != ""
                    );

                    if (itemsADevolver.length === 0) {
                        self.showAlert({
                            icon: "warning",
                            title: "Ingrese fecha de devolución en al menos un item",
                            vm: self,
                        });
                        return;
                    }

                    axios
                        .post("/SSGG/GuardarDevolucion", itemsADevolver)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.vaciarModels();
                            self.showAlert({
                                icon: "success",
                                title: "Devolución guardada con éxito",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                }
            });
        },

        vaciarModels() {
            this.bienesdevueltos = [];
            this.remito = "";
            this.equipo = "";
            this.deposito = "";
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>